import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent, PasswordComponent } from './components/auth';
import { DashboardComponent} from './components/dashboard';
import { ProfileComponent } from './components/profile';
import { UsersComponent, UsersListComponent, UsersViewComponent, UsersConfigComponent, UsersRolesComponent } from './components/users';
import { ValidationComponent } from './components/validation';
import { ValidatorsComponent, ValidatorsListComponent, ValidatorsViewComponent, ValidatorsOptionsComponent, ValidatorsConfigComponent, ValidatorConfigListComponent, ValidatorsConfigViewComponent, ValidatorsConfigPermissionComponent } from './components/validators';
import { CamerasComponent } from './components/cameras';
import { AuthGuard } from './services';
import { ReservationRetailCancelComponent, ReservationRetailComponent } from './components/reservation-retail';
import { HotParkingComponent, PubHotParkingComponent } from './components/hot-parking';
import { ReservationTenantsComponent, ReservationTenantsListComponent, ReservationTenantsDetailsComponent } from './components/reservation-tenants';
import { LprComponent } from './components/lpr';
import { ValidationReportComponent } from './components/validation-report/validation-report.component';


const routes: Routes = [
  {
    path: '', component: DashboardComponent, data: { breadcrumb: 'Start' },
    children: [
      {
        path: 'reservation-retail', component: ReservationRetailComponent, pathMatch: 'full', data: { breadcrumb: 'Rezerwacja miejsca' }
      },
      {
        path: 'reservation-retail-cancel', component: ReservationRetailCancelComponent, pathMatch: 'full', data: { breadcrumb: 'Anulowanie rezerwacji' }
      },
      {
        path: 'reservation-retail-cancel/:qrCode', component: ReservationRetailCancelComponent, pathMatch: 'full', data: { breadcrumb: 'Anulowanie rezerwacji' }
      },
      {
        path: 'profile', component: ProfileComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Profil' }
      },
      {
        path: 'validation', component: ValidationComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Walidacja', expectedRoles: ['AdministratorRole', 'ValidationOperatorRole']}
      },
      {
        path: 'hotparking', component: HotParkingComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Hot Parking', expectedRoles: ['AdministratorRole', 'HotParkingOperatorRole'] }
      },
      {
        path: 'pub-hotparking', component: PubHotParkingComponent, data: { breadcrumb: 'Hot Parking' }
      },
      {
        path: 'reservation', component: ReservationTenantsComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Reserwacja miejsca dla gości - lista', expectedRoles: ['AdministratorRole', 'ReservationOperatorRole'] },
        children: [
          {
            path: '', component: ReservationTenantsListComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Rezerwacja miejsca dla gości - lista', expectedRoles: ['AdministratorRole', 'ReservationOperatorRole'] }
          },
          {
            path: 'details', component: ReservationTenantsDetailsComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Nowa rezerwacja', expectedRoles: ['AdministratorRole', 'ReservationOperatorRole'] } 
          },
          {
            path: 'details/:id', component: ReservationTenantsDetailsComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Podgląd rezerwacji', expectedRoles: ['AdministratorRole', 'ReservationOperatorRole'] }
          }
        ]
      },
      {
        path: 'lpr', component: LprComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Rozpoznania tablic rejestracyjnych', expectedRoles: ['AdministratorRole', 'LprOperatorRole'] }
      },
      {
        path: 'users', component: UsersComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Administracja użytkownikami', expectedRoles: ['AdministratorRole'] },
        children: [
          {
            path: '', component: UsersListComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Lista użytkowników', expectedRoles: ['AdministratorRole'] }
          },
          {
            path: 'user', component: UsersViewComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Nowy użytkownik', expectedRoles: ['AdministratorRole'] }
          },
          {
            path: 'user/:id', component: UsersViewComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Edycja użytkownika', expectedRoles: ['AdministratorRole'] }
          },
          {
            path: 'user/:id/config', component: UsersConfigComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Konfiguracje', expectedRoles: ['AdministratorRole'] }
          },
          {
            path: 'user/:id/roles', component: UsersRolesComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Role', expectedRoles: ['AdministratorRole'] }
          },
        ]
      },
      {
        path: 'validators', component: ValidatorsComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Administracja walidatorami', expectedRoles: ['AdministratorRole'] },
        children: [
          { path: '', component: ValidatorsListComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Walidatory', expectedRoles: ['AdministratorRole'] } },
          { path: 'details', component: ValidatorsViewComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Szczegóły', expectedRoles: ['AdministratorRole'] } },
          {
            path: 'options', component: ValidatorsOptionsComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Opcje', expectedRoles: ['AdministratorRole'] },
          },
          {
            path: ':id/configs', component: ValidatorsConfigComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Konfiguracje', expectedRoles: ['AdministratorRole'] },
            children: [
              { path: '', component: ValidatorConfigListComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Konfiguracje', expectedRoles: ['AdministratorRole'] } },
              { path: ':id', component: ValidatorsConfigViewComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Szczegóły', expectedRoles: ['AdministratorRole'] } },
              { path: ':id/permission', component: ValidatorsConfigPermissionComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Pozwolenia', expectedRoles: ['AdministratorRole'] } }
            ]
          }
        ]
      },
      {
        path: 'validation-report', component: ValidationReportComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Raporty eWalidacji', expectedRoles: ['AdministratorRole'] }
      },
    ]
  },
  {
    path: 'cameras', component: CamerasComponent, pathMatch: 'full', data: { breadcrumb: 'Podgląd kamer' }
  },
  { path: 'login', component: AuthComponent, pathMatch: 'full' },
  { path: 'passwd', component: PasswordComponent, pathMatch: 'full' },
  { path: '**', redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
